import { isMobile } from '../helpers/isMobile';
import {
  appendActiveFiltersIndication, updateRowCount, toggleMobileMenu,
  renderActiveFiltersFromState, resetFiltersDom, removeActiveFilterFromState,
  resetState, resetAllTableFilters, setNewTableFilter
} from './tableFilterHelpers';

/**
 * Toggles single filter on/off. When the filter is toggled, the button active/inactive
 * appearance is set, the temp state is updated, while the number of table rows that
 * would be displayed if the filters are applied is updated.
 * @param {Event} event Click event
 * @param {Object} classObj Class instance
 */
export function onFilterToggle(event, classObj) {
  const $currentTarget = $(event.currentTarget);
  $currentTarget.toggleClass('table-filter-btn--is-active');
  $currentTarget.attr('aria-pressed', $currentTarget.hasClass('table-filter-btn--is-active'));
  const $filterGroup = $currentTarget.parents('.js-table-filter-item');
  const $activeFilters = $filterGroup.find('.js-table-filter-item-active');
  const filterGroup = $filterGroup.data('filter-group');
  const name = $currentTarget.data('filter-name');
  let label = event.currentTarget.innerText;
  let filterColumn = $currentTarget.parent().closest('ul').attr('column');

  if ($currentTarget.hasClass('table-filter-btn--is-active')) {
    classObj.tempState.activeFilters.push({
      filterGroup,
      label,
      name,
      filterColumn
    });
    appendActiveFiltersIndication($activeFilters, label, name);
  } else {
    removeActiveFilterFromState(classObj.tempState, name);
    $activeFilters.find(`.js-table-filter-single-active[data-filter-name="${name}"]`).remove();
  }

  !isMobile() && onFilterApply(classObj);
  resetAllTableFilters();
  setNewTableFilter(classObj.tempState);
  updateRowCount();
}

/**
 * Select all items within a filter group and apply them as active filters.
 *
 * @param {jQuery} $filter - The jQuery object representing the filter container.
 * @param {Object} classObj - An object containing information and methods related to the class.
 */
function selectAll($filter, classObj) {
  $filter.find('.js-list-select-all').off('click.tableFilterSelectAll').on('click.tableFilterSelectAll', () => {
    const filterGroup = $filter.data('filter-group');
    $filter.find('.js-table-filter-btn').each(function() {
      const $filterBtn = $(this);
      const name = $filterBtn.data('filter-name');

      if (!classObj.tempState.activeFilters.some(filter => filter.name === name)) {
        const label = $filterBtn.text();
        const filterColumn = $filterBtn.closest('ul').attr('column');

        classObj.tempState.activeFilters.push({
          filterGroup,
          label,
          name,
          filterColumn
        });
      }
    });

    onFilterApply(classObj);
    resetAllTableFilters();
    setNewTableFilter(classObj.tempState);
    updateRowCount();
  });
}

/**
 * Toggle filter item group appearance
 * On mobile screens toggles accordion, on desktop a dropdown.
 * @param {JQuery} $filter
 * @param {Object} classObj - class instance
 */
export function onFilterGroupToggle($filter, classObj) {
  const isOpen = $filter.hasClass('table-filter-item--is-active');
  const $openFilters = $('.table-filter-item--is-active');

  $('body').off('click.tableFilter');

  $openFilters
    .removeClass('table-filter-item--is-active')
    .find('.js-table-filter-item-toggle')
      .attr('aria-expanded', 'false');
  $openFilters.find('.js-table-filter-icon')
    .addClass('icon-arrow-down')
    .removeClass('icon-arrow-up');
  $filter.find('.js-table-filter-icon')
    .toggleClass('icon-arrow-down', isOpen)
    .toggleClass('icon-arrow-up', !isOpen);

  const closeFilter = event2 => {
    // if the target of the click isn't the container nor a descendant of the container
    if (!$filter.is(event2.target) && $filter.has(event2.target).length === 0) {
      onFilterItemClose($filter, classObj);
    }
  }

  if (!isOpen) {
    $filter.addClass('table-filter-item--is-active');
    $filter.find('.js-table-filter-item-toggle').attr('aria-expanded', 'true');
    if (!isMobile()) {
      $('body').on('click.tableFilter', closeFilter);
    }
    let $arrow = $filter.find('.arrow');
    if (!$arrow.length) {
      $arrow = $('<div class="arrow"></div>');
      $filter.append($arrow);
    }
    $arrow.css({ left: ($filter.width() / 2) - ($arrow.width() / 2) });
  }

  updateRowCount();
  selectAll($filter, classObj);
}

/**
 * Close filter accordion / dropdown
 * @param {JQuery} $filter
 * @param {Object} classObj - class instance
 */
export function onFilterItemClose($filter, classObj) {
  $('body').off('click.tableFilter');
  $filter.removeClass('table-filter-item--is-active')
    .find('.js-table-filter-icon')
      .addClass('icon-arrow-down')
      .removeClass('icon-arrow-up');
  $filter.find('.js-table-filter-item-toggle').attr('aria-expanded', 'false');

  if (!isMobile()) {
    resetState(classObj.tempState, classObj.state);
    renderActiveFiltersFromState(classObj.state);
  }
}

/**
 * Reset all filters and show all table rows
 * @param {Object} classObj - class instance
 */
export function onFilterResetAll(classObj) {
  resetFiltersDom();
  classObj.state.activeFilters = [];
  resetAllTableFilters();

  resetState(classObj.tempState, classObj.state);
  updateRowCount();
  $('.js-table-filter').removeClass('table-filter--has-applied-filters');
}

/**
 * Close modal window. Cache new filters state. Update filters UI and finally filter table.
 * @param {Object} classObj - Class instance
 */
export function onFilterApply(classObj) {
  toggleMobileMenu(classObj, false);
  resetState(classObj.state, classObj.tempState);
  renderActiveFiltersFromState(classObj.state);
  $('.js-table-filter').toggleClass('table-filter--has-applied-filters',
    classObj.state.activeFilters.length > 0);
}

/**
 * Close modal window on X icon.
 * @param {Object} classObj - Class instance
 */
export function onModalClose(classObj) {
  resetState(classObj.tempState, classObj.state);
  updateRowCount();
  resetAllTableFilters();
  setNewTableFilter(classObj.state);
}

/**
 * Deactivate applied single filter on x click.
 * @param {Event} event click event
 * @param {Object} classObj - class instance
 */
export function onFilterDeactivate(event, classObj) {
  const $filterRemove = $(event.currentTarget);
  const $filter = $filterRemove.parents('.js-table-filter-applied-item');
  const filterName = $filterRemove.data('filter-name');
  const filterGroupName = $filter.data('filter-group');
  const $filterGroup = $(`.js-table-filter-item[data-filter-group="${filterGroupName}"]`);

  $filter.remove();
  $filterGroup.find(`[data-filter-name="${filterName}"]`)
    .removeClass('table-filter-btn--is-active')
    .attr('aria-pressed', 'false');

  if ($filterGroup.find('.table-filter-btn--is-active').length === 0) {
    $filterGroup.removeClass('table-filter-item--is-applied');
  }

  removeActiveFilterFromState(classObj.state, filterName);
  resetState(classObj.tempState, classObj.state);
  toggleMobileMenu(classObj, false);

  $('.js-table-filter').toggleClass('table-filter--has-applied-filters', classObj.state.activeFilters.length > 0);
  $('.js-table-filter-nothing-applied').toggleClass('u-display-none', classObj.state.activeFilters.length > 0);

  resetAllTableFilters();
  setNewTableFilter(classObj.state);
}
